module.exports = __webpack_public_path__ + "img/result3.e6a57a4f.png";